import React, { useContext, useEffect } from "react";
import {
    QueryClient,
    QueryClientProvider,
    useMutation,
    useQuery,
  } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import StudyListTable from "../../../../components/StyleListTable/StudyListTable";
import studylistContext from "../../../../context/studylist/StudylistContext";
import userContext from "../../../../context/users/UserContext";
const queryClient = new QueryClient();


const StudyListTableContainer = (props) => {

    const {
        sortGlobal,
        filterInputValues,
        roles,
        refreshRequired,
        selectedValue,
        filterApplied,
        fetchData,
        checkForConditionRequired,
        paginationObj, setPaginationObj,
        handleChangeSizeIndex,
        handleRefresh
      } = useContext(studylistContext);
    const setDataQueryParent = props.setDataQueryParent;

    return (
        <>
        <QueryClientProvider client={queryClient}>
              <>
                {selectedValue === "study_1" && (checkForConditionRequired(filterInputValues?.showAllStudies)) && (
                  <>
                    <StudyListTable
                      id="unreported"
                      refreshRequired={refreshRequired}
                      fetchData={fetchData}
                      pageObj={paginationObj.unreported}
                      sortObj={sortGlobal}
                      filterObj = {filterApplied}
                      handleChangeSizeIndex={handleChangeSizeIndex}
                      setDataQueryParent={setDataQueryParent}
                      roles={roles}
                      refresh = {handleRefresh}
                      showAllStudies = {filterInputValues.showAllStudies}
                    />
                  </>
                )}
                {selectedValue === "study_26" && (
                  <StudyListTable
                    id="draft"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.draft}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_2" &&  (
                  <StudyListTable
                    id="saved"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.saved}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_3" && (
                  <StudyListTable
                    id="reported"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.reported}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_22" && (
                  <StudyListTable
                    id="positive"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.positive}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_23" && (
                  <StudyListTable
                    id="negative"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.negative}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_25" && (
                  <StudyListTable
                    subTabId="resubmission"
                    id="reported"
                    paginationKey="reportedResubmission"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.reportedResubmission}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_4" && (
                  <StudyListTable
                    id="closed"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.closed}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_5" && (
                  <StudyListTable
                    id="qcreview"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.qcreview}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_24" && (
                  <StudyListTable
                    id="qcreviewAssigned"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.qcreviewAssigned}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_6" && (
                  <StudyListTable
                    id="qcfix"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.qcfix}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_7" && (
                  <StudyListTable
                    id="qcverify"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.qcverify}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_8" && (
                  <StudyListTable
                    id="returned"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.returned}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_9" && (
                  <StudyListTable
                    id="critical"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.critical}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_10" && (
                  <StudyListTable
                    id="library"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.library}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_11" && (
                  <StudyListTable
                    id="normal"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.normal}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_12" && (
                  <StudyListTable
                    id="normalwithfb"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.normalwithfb}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_13" && (
                  <StudyListTable
                    id="abnormal"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.abnormal}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_14" && (
                  <StudyListTable
                    id="reviewAssigned"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.reviewAssigned}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_15" && (
                  <StudyListTable
                    id="reviewComplete"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.reviewComplete}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_16" && (
                  <StudyListTable
                    id="evaluationAssigned"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.evaluationAssigned}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_17" && (
                  <StudyListTable
                    id="evaluationComplete"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.evaluationComplete}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
				        {selectedValue === "study_18" && (
                  <StudyListTable
                    id="pending"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.pending}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_19" && (
                  <StudyListTable
                    id="approved"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.approved}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_20" && (
                  <StudyListTable
                    id="rejected"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.rejected}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
                {selectedValue === "study_21" &&  (
                  <StudyListTable
                    id="reviewPending"
                    refreshRequired={refreshRequired}
                    filterObj = {filterApplied}
                    fetchData={fetchData}
                    pageObj={paginationObj.reviewPending}
                    sortObj={sortGlobal}
                    handleChangeSizeIndex={handleChangeSizeIndex}
                    setDataQueryParent={setDataQueryParent}
                    roles={roles}
                    refresh = {handleRefresh}
                    showAllStudies = {filterInputValues.showAllStudies}
                  />
                )}
               
              </>
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}

              <ReactQueryDevtools initialIsOpen />
            </QueryClientProvider>
        </>
    )
}


export default StudyListTableContainer;